import React from 'react';
import { useNavigateToPage, usePreviousPage } from '../../contexts/NavigationContext';

/**
 * "← Back to POS" shown only when the user arrived from the POS (desktop or mobile), e.g. via the
 * header notification bell — so staff can jump back to taking orders in one tap.
 */
const BackToPosButton: React.FC = () => {
  const previousPage = usePreviousPage();
  const navigate = useNavigateToPage();
  if (!navigate || (previousPage !== 'pos' && previousPage !== 'pos-mobile')) return null;

  return (
    <button
      type="button"
      onClick={() => navigate(previousPage)}
      className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-gray-800 text-white text-sm font-semibold hover:bg-gray-700"
    >
      ← Back to POS
    </button>
  );
};

export default BackToPosButton;
